import React, { memo, useEffect, useCallback } from 'react';

import { View, StyleSheet, Pressable, Text } from 'react-native';
import { THEME, FONT, COLOR, __WEB__ } from '../../constants/styles';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { changeCurrentCase, openCaseInfo, resetState } from './actions';
import { getCurrentEmployer } from '../../selectors/entities';
import { setCalendarViewEmployer } from '../calendar/actions';

import { Navigation, NavBar, I18n } from '../components';

import CaseSearchList from './case_search_list';

const SelectCase = memo((props) => {
  useEffect(
    NavBar.setup(
      props,
      !__WEB__ && {
        buttons: { leftButtons: [NavBar.buttons.done] },
      }
    ),
    []
  );

  const handleSelectCase = useCallback(
    (caseId) => {
      if (props.changeEditingCase) {
        props.actions.openCaseInfo(caseId);
      } else {
        props.actions.changeCurrentCase(caseId);
        setTimeout(() => {
          props.actions.setCalendarViewEmployer(false);
        }, 100);
      }
      Navigation.close(props);
    },
    [props.changeEditingCase, props.actions, props]
  );

  const handleResidentSelectValueChange = useCallback(() => {}, []);

  const handleSelectAllResidents = useCallback(() => {
    props.actions.resetState();
    props.actions.setCalendarViewEmployer(true);
    Navigation.close(props);
  }, [props.actions, props]);

  return (
    <View style={styles.container}>
      {!!props.includeEmployerSelection && (
        <Pressable style={styles.allResidentsBtn} onPress={handleSelectAllResidents}>
          <Text style={styles.allResidentsLabel}>Show {I18n.aec('allResidents')}</Text>
        </Pressable>
      )}
      <View style={styles.listContainer}>
        <CaseSearchList
          onValueChange={handleResidentSelectValueChange}
          onSelectCase={handleSelectCase}
          autoFocus={false}
          loadOnInit={true}
          filters={props.filters}
          employerId={props.employer?.employerId}
        />
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    ...THEME.container,
    alignItems: 'center',
    backgroundColor: COLOR.modalBackground,
  },
  listContainer: {
    flex: 1,
    width: __WEB__ ? 400 : '100%',
  },
  residentsLabel: {
    ...FONT.semibold,
  },
  allResidentsBtn: {
    alignSelf: 'stretch',
    backgroundColor: COLOR.altContrast,
    paddingVertical: 15,
    paddingHorizontal: 25,
  },
  allResidentsLabel: {
    ...THEME.linkStyle,
    fontSize: 20,
  },
});

function mapStateToProps(state, ownProps) {
  return {
    employer: getCurrentEmployer(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { changeCurrentCase, setCalendarViewEmployer, openCaseInfo, resetState },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectCase);
